import React from 'react';
import classnames from 'classnames';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';
import {getBreakLinesTextShumaType3} from "../../../utils/texts";

const Section6Text78d = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {
    houseAreaAccordingTasritMeher,
  } = context.data.pdfData;

    return (
      <div ref={ref}>
        {Boolean(houseAreaAccordingTasritMeher) && (
          <div className={classnames(styles.itemText, styles.innerPadding)}>
            <span className={styles.bold}>שטח בהתאם לתשריט מכר: </span>
            <span>{getBreakLinesTextShumaType3(houseAreaAccordingTasritMeher)}</span>
          </div>
        )}
      </div>
    )
});

export default Section6Text78d;
